import { IHexSpaceData } from 'js/bubbleCore/types';

export function loopSpace<T>(space: IHexSpaceData<T>, callback: (value: T) => void) {
  space.values.forEach(callback);
}